module.exports = __webpack_public_path__ + "img/foot_w.a6d35a1f.svg";